import { splitByComma } from '../utils/splitByComma';

const DEFAULT_TRUSTED_ORIGINS = ['claramobile://', 'ignite://'] as const;

function toAllowedHost(value: string): string {
  if (!value.includes('://')) return value;

  try {
    const url = new URL(value);
    if (url.protocol === 'http:' || url.protocol === 'https:') {
      return url.host;
    }
  } catch {
    return value;
  }

  return value;
}

export function getAllowedHosts(defaultHost: string): string[] {
  const allowedHosts = splitByComma(process.env.ALLOWED_HOSTS);
  if (allowedHosts.length > 0) return allowedHosts.map(toAllowedHost);

  const authUrlHost = splitByComma(process.env.NEXT_PUBLIC_BETTER_AUTH_URL).map(toAllowedHost);
  if (authUrlHost.length > 0) return authUrlHost;

  return [defaultHost];
}

/** Canonical URL used when a request arrives on a host outside the allowlist. */
export function getAuthFallbackUrl(): string | undefined {
  const [fallback] = splitByComma(process.env.NEXT_PUBLIC_BETTER_AUTH_URL);
  return fallback;
}

export function getTrustedOrigins(): string[] {
  return Array.from(
    new Set([
      ...DEFAULT_TRUSTED_ORIGINS,
      ...splitByComma(process.env.BETTER_AUTH_TRUSTED_ORIGINS),
    ])
  );
}
